import axios from "axios";
const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;

export const axiosClient = axios.create({
  baseURL: `${REACT_APP_BASE_URL}` || "https://app.u-sendfulfillment.com/api/v1",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});
